module.exports = __webpack_public_path__ + "static/media/carruselManual.49df24a4.png";